import { MinimumStationsGroup, Station, StationType } from '@app/core/types/stations';

export enum OptionType {
  StationType = 'STATION_TYPE',
  StationGroup = 'STATION_GROUP',
  IndividualStation = 'STATION_INDIVIDUAL',
}

// Base interface for all filter options
export interface BaseFilterOption {
  label: string;
  type: OptionType;
}

// Station type filter option
export interface StationTypeFilterOption extends BaseFilterOption {
  type: OptionType.StationType;
  value: StationType;
}

// Station group filter option
export interface StationGroupFilterOption extends BaseFilterOption {
  type: OptionType.StationGroup;
  value: MinimumStationsGroup;
}

// Individual station filter option
export interface IndividualStationFilterOption extends BaseFilterOption {
  type: OptionType.IndividualStation;
  value: Station;
}

// Union type for all possible options
export type StationFilterOption =
  | StationTypeFilterOption
  | StationGroupFilterOption
  | IndividualStationFilterOption;
